var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsDateString, IsNumber, IsString, IsUUID } from 'class-validator';
import { ExerciseFullSizeDto } from './exercise.full-size.dto.js';
export class BodyRegionFullSizeDto {
    id;
    createdAt;
    updatedAt;
    title;
    sortingIndex;
    exercises;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BodyRegionFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], BodyRegionFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], BodyRegionFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], BodyRegionFullSizeDto.prototype, "title", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], BodyRegionFullSizeDto.prototype, "sortingIndex", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], BodyRegionFullSizeDto.prototype, "exercises", void 0);
//# sourceMappingURL=body-region.full-size.dto.js.map